import { observable } from 'mobx'

export class StorydocStoreUI {
  @observable currentSlideIdx: number = 0
  @observable showArrows: boolean = false
  @observable scrollPositions: {[key: number]: number} = {}
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/storydocStoreUI.tsx